(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/helpers/handlebars-helper.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/helpers/handlebars-helper.js');

(function() {
  'use strict';

  if (typeof exports === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }


  function registerHelpers(hbs) {
    hbs.registerHelper('trendArrow', function(trend, options) {
      var model = {};

      if (trend === 2) {
        model.color = 'green';
        model.arrow = 'positive';
      } else if (trend === 1) {
        model.color = 'green';
        model.arrow = 'up';
      } else if (trend === 0) {
        model.color = 'yellow';
        model.arrow = 'neutral';
      } else if (trend === -1) {
        model.color = 'red';
        model.arrow = 'down';
      } else if (trend === -2) {
        model.color = 'red';
        model.arrow = 'negative';
      }

      return options.fn(model);
    });

    hbs.registerHelper('gameDate', function(dateString) {
      var inDate = dateFns.startOfDay(new Date(dateString)),
        today = dateFns.startOfDay(new Date()),
        gameDate = new Date(dateString),
        includeTime = arguments[1] || false;
      if (inDate.isValid()) {
        var formattedDate;
        switch (inDate.diff(today, 'days')) {
          case -1:
            formattedDate = 'igår';
            break;
          case 0:
            formattedDate = 'idag';
            break;
          case 1:
            formattedDate = 'imorgon';
            break;
          default:
            formattedDate = dateFns.format(gameDate, 'd/M');
            break;
        }
        return includeTime
          ? formattedDate + ' ' + dateFns.format(gameDate, 'HH:mm')
          : formattedDate;
      }
      return '';
    });

    hbs.registerHelper('formatNetSale', function(amount) {
      amount = parseInt(amount, 10);
      amount = svs.utils.format.CurrencyFromJupiterString(amount);
      amount =
        amount > 999999
          ? svs.utils.format.CurrencyInMillions(amount) + ' milj kr'
          : svs.utils.format.Currency(amount, false) + ' kr';
      return amount;
    });

    hbs.registerHelper('numWeeksEquals', function(num, options) {
      return svs.maltipset.collections.coupons.models[0].get('numWeeks') === num
        ? options.fn(this)
        : options.inverse(this);
    });
    hbs.registerHelper('isSingleRow', function(options) {
      if (
        !svs.maltipset.collections.coupons.getCurrentCoupon().isMOrRSystem()
      ) {
        return options.fn(this);
      }
      return options.inverse(this);
    });
    hbs.registerHelper('isMOrRSystem', function(options) {
      if (svs.maltipset.collections.coupons.getCurrentCoupon().isMOrRSystem()) {
        return options.fn(this);
      }
      return options.inverse(this);
    });
    hbs.registerHelper('xpertBaseRowMode', function(options) {
      if (
        svs.maltipset.collections.coupons
          .getCurrentCoupon()
          .get('xpertBaseRowMode')
      ) {
        return options.fn(this);
      }
      return options.inverse(this);
    });
    hbs.registerHelper('addOne', function(num) {
      return num + 1;
    });
    hbs.registerHelper('hasComment', function(index, options) {
      if (
        svs.maltipset.collections.coupons
          .getCurrentCoupon()
          .get('draw')
          .get('matchList')
          .models[index].get('eventComment') != ''
      ) {
        return options.fn(this);
      }
      return options.inverse(this);
    });
  }
})();


 })(window);